import React from 'react';

export default function RideCardSkeleton() {
  return (
    <div className="bg-white/10 backdrop-blur-sm border border-white/20 border-l-4 border-l-white/20 rounded-2xl p-6 animate-pulse">
      <div className="flex items-center justify-between mb-4">
        <div className="space-y-1.5">
          <div className="h-3 w-16 bg-white/20 rounded" />
          <div className="h-3 w-24 bg-white/10 rounded" />
        </div>
        <div className="h-7 w-24 bg-white/20 rounded-full" />
      </div>

      <div className="bg-white/10 rounded-xl p-4 mb-4 space-y-2 border border-white/10">
        <div className="flex items-center gap-2.5">
          <div className="w-2.5 h-2.5 rounded-full bg-white/20 shrink-0" />
          <div className="h-3 w-3/4 bg-white/20 rounded" />
        </div>
        <div className="ml-[5px] border-l-2 border-dashed border-white/20 h-3" />
        <div className="flex items-center gap-2.5">
          <div className="w-2.5 h-2.5 rounded-full bg-white/20 shrink-0" />
          <div className="h-3 w-1/2 bg-white/20 rounded" />
        </div>
      </div>

      <div className="flex items-center justify-between">
        <div className="h-7 w-16 bg-white/20 rounded" />
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-full bg-white/20" />
          <div className="h-3 w-20 bg-white/20 rounded" />
        </div>
      </div>
    </div>
  );
}
